module.exports = __webpack_public_path__ + "static/media/09.3572f43a.jpg";